import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

const PRIMARY = {
  // lighter: '#D1E9FC',
  // light: '#76B0F1',
  // main: '#2065D1',
  // dark: '#103996',
  // darker: '#061B64',
  // contrastText: '#fff',

  lighter: '#00ea9b',
  light: '#00bf7f',
  main: '#00a76f',
  dark: '#007f54',
  darker: '#005a3c',
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#000000',
  light: '#000000',
  main: '#000000',
  dark: '#000000',
  darker: '#000000',
  contrastText: '#fff',
};

const BLUE = {
  lighter: '#D1E9FC',
  light: '#76B0F1',
  main: '#2065D1',
  dark: '#103996',
  darker: '#061B64',
  contrastText: '#fff',
};

const PURPLE = {
  lighter: '#F3E5F5',
  light: '#BA68C8',
  main: '#7B1FA2',
  dark: '#4A148C',
  darker: '#38006B',
  contrastText: '#fff',
};

const TEAL = {
  lighter: '#B2DFDB',
  light: '#4DB6AC',
  main: '#00897B',
  dark: '#00695C',
  darker: '#004D40',
  contrastText: '#fff',
};

const ORANGE = {
  lighter: '#FFE0B2',
  light: '#FFB74D',
  main: '#F57C00',
  dark: '#E65100',
  darker: '#BF360C',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D',
  contrastText: GREY[800],
};

const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800],
};

const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff',
};

const greenTag = {
  main: '#118d57',
  back:'#d3efdf'
}

const redTag = {
  main: '#b71d18',
  back:'#f7ddd8'
}

const blueTag = {
  main: '#2f4ebf',
  back:'#d8e8f7'
}

const orangeTag = {
  main: '#b76e00',
  back:'#f7ead0'
}

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  blue: BLUE,
  purple: PURPLE,
  teal: TEAL,
  orange: ORANGE,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: GREY[800],
    secondary: GREY[600],
    tertiary: GREY[900],
    disabled: GREY[500],
  },
  background: {
    paper: '#fff',
    default: GREY[100],
    neutral: GREY[200],
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(PRIMARY.lighter, 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
